export default __webpack_public_path__ + "static/media/img_regua_vertical.7e88cc65.png";